






import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

/**
 * LOGO组件
 */
@Component
export default class Logo extends Vue {
  /**
   * LOGO图片地址
   */
  @Prop({ default: '' })
  pic!: string;

  /**
   * LOGO容器宽度
   */
  @Prop({ default: 200 })
  width!: number;

  /**
   * LOGO容器高度
   */
  @Prop({ default: 50 })
  height!: number;

  /**
   * LOGO背景图片尺寸
   */
  // @Prop({ default: () => [200, 50] })
  // backgroundSize!: number[];

  @Prop({ default: false })
  covered!: boolean;

  /**
   * 样式
   */
  get styles() {
    let {
      width,
      height,
      covered,
      // backgroundSize: [bgWidth, bgHeight],
      pic
    } = this;

    return {
      width: `${width}px`,
      height: `${height}px`,
      // backgroundSize: !covered ? `${bgWidth}px ${bgHeight}px` : 'cover',
      backgroundImage: pic ? `url(${pic})` : '',
      transition: 'width ease .2s'
    };
  }
}
